export default __webpack_public_path__ + "static/media/review_event_banner.c7333c56.jpg";